import React from 'react';
import { GiftMembersProvider } from 'contexts/gift-members.context';
import GiftMembersContent from './content';

const GiftMembersLayout = () => {
  return (
    <GiftMembersProvider>
      <GiftMembersContent />
    </GiftMembersProvider>
  );
};

export default GiftMembersLayout;
